import * as React from "react";
import { connect } from "react-redux";
import { FillUp } from "@vwpfs/mary-air-lib/components/air/04-helpers/FillUp";
import { Alignment, ButtonsWrapper, Orientation } from "@vwpfs/mary-air-lib/components/air/06-molecules/ButtonsWrapper";
import { Navbar } from "@vwpfs/mary-air-lib/components/air/07-organisms";
import { DispatchFunc } from "../../../../../../../store/ActionTypes";
import { remoteTrigger } from "../../../../../../../store/RemoteActions";
import { RemoteScope } from "../../../../../../../store/RemoteTypes";
import { BookedObjectTypeDisplay } from "../../../../../../../store/Statements/Displays";
import { BookedObjectType } from "../../../../../../../store/Statements/Types";
import { ThemePaletteState, ThemePalette, ThemeBreakpoints } from "@vwpfs/mary-air-lib/theme/_Types";
import { modalClose } from "../../../../../../../utils/redux/ActionTypes";
import { FlexColumn } from "@vwpfs/mary-air-lib/components/air/03-base/Flex/Column";
import { FlexRow } from "@vwpfs/mary-air-lib/components/air/03-base/Flex/Row";
import { Container } from "@vwpfs/mary-air-lib/components/air/03-base/Container";
import { Button } from "@vwpfs/mary-air-lib/components/air/05-atoms/Button";
import { IconNames } from "@vwpfs/mary-air-lib/components/air/05-atoms/Icon";
import { NavbarStack,
    NavbarStackContent, NavbarStackRight } from "@vwpfs/mary-air-lib/components/air/07-organisms/Navbar/Stack";
import { NavbarTitle } from "@vwpfs/mary-air-lib/components/air/07-organisms/Navbar/Title";
import { NavbarIcon } from "@vwpfs/mary-air-lib/components/air/07-organisms/Navbar/Icon";


/**
 *
 */
interface OwnProps {
    modalID: string;
    id: string;
    statementId: string;
    objectId: number;
    type: BookedObjectType;
}

/**
 *
 */
interface DispatchProps {
    closeModal: (id: string) => void;
    unbookRequest: (objectId: number, type: BookedObjectType, statementLineId: string, statementId: string) => void;
}

/**
 *
 */
type Props = OwnProps & DispatchProps;

/**
 *
 */
export const mapDispatchToProps = (dispatch: DispatchFunc): DispatchProps => ({
    closeModal: (id: string) => {
        dispatch(modalClose(id));
    },
    unbookRequest: (objectId: number, type: BookedObjectType, statementLineId: string, statementId: string) => {
        dispatch(remoteTrigger(
            RemoteScope.STATEMENT_UNBOOK_PATCH,
            {
                patch: {
                    bookedObjectId: objectId,
                    bookedObjectType: type,
                },
                statementLineId: statementLineId,
                statementId: statementId,
                modalID: statementLineId,
            },
        ));
    },
});

export const closeModal = (props: Props) => () => props.closeModal(props.modalID);

export const unbookRequest = (props: Props) => () =>
    props.unbookRequest(props.objectId, props.type, props.id, props.statementId);

/**
 *
 * @param props
 */
const UnbookLineComp: React.FunctionComponent<Props> = (props) => (
    <FlexColumn
    >
        <FlexRow isFixed>
            <Navbar
                theme={{
                    paletteState: ThemePaletteState.DANGER,
                }}
            >
                <NavbarStack>
                    <NavbarStackContent>
                        <NavbarTitle>
                            Unbook
                        </NavbarTitle>
                    </NavbarStackContent>
                    <NavbarStackRight>
                        <NavbarIcon>
                            <Button icon={IconNames.TIMES}
                                link={{
                                    onClick: closeModal(props),
                                }}
                            />
                        </NavbarIcon>
                    </NavbarStackRight>
                </NavbarStack>
            </Navbar>
        </FlexRow>
        <FlexRow
            theme={{
                palette: ThemePalette.CONTRAST_PRIMARY,
            }}
        >
            <FlexColumn>
                <FlexRow isScrollable >
                    <FillUp>
                        <Container
                            theme={{
                                padding: {
                                    "": { y: 3 },
                                    "md": { y: 4 },
                                },
                            }}
                        >
                            You are about to unbook the {BookedObjectTypeDisplay[props.type]}.
                            <br /><br />
                            This action cannot be undone.
                            <br /><br />
                            <b>Are you sure you want to unbook this booking?</b>
                        </Container>
                    </FillUp>
                </FlexRow>
            </FlexColumn>
        </FlexRow>
        <FlexRow isFixed>
            <FlexColumn
                theme={{
                    palette: ThemePalette.CONTRAST_SECONDARY,
                }}
            >
                <Container
                    theme={{
                        padding: { "": { y: 3 } },
                    }}
                >
                    <ButtonsWrapper
                        defaultOrientation={Orientation.HORIZONTAL}
                        orientations={{
                            [ThemeBreakpoints.XS]: Orientation.VERTICAL,
                            [ThemeBreakpoints.MD]: Orientation.HORIZONTAL,
                        }}
                        alignment={Alignment.RIGHT}
                    >
                        <Button
                            theme={{ palette: ThemePalette.CONTRAST_SECONDARY }}
                            link={{ onClick: closeModal(props) }}
                        >
                            Cancel
                        </Button>
                        <Button
                            theme={{ palette: ThemePalette.BRAND_ACCENT }}
                            link={{ onClick: unbookRequest(props) }}
                        >
                            Yes
                        </Button>
                    </ButtonsWrapper>
                </Container>
            </FlexColumn>
        </FlexRow>
    </FlexColumn >
);

/**
 *
 */
export const UnbookLineModal = connect(
    undefined,
    mapDispatchToProps,
)(UnbookLineComp);
